import Image from 'next/image';
import cn from 'classnames';

const LogoGridUI = ({ text, customers }) => (
  <div>
    {text && (
      <p className="mx-auto mb-20 text-lg leading-8 text-center max-w-max md:text-left">
        {text}
      </p>
    )}
    <div
      className={cn('grid gap-8 sm:gap-16 md:gap-20 w-4/5 mx-auto', {
        'grid-cols-1': customers.length === 1,
        'grid-cols-2': customers.length === 2,
        'grid-cols-3': customers.length === 3,
        'grid-cols-3 md:grid-cols-4 lg:grid-cols-4': customers.length === 4,
        'grid-cols-3 md:grid-cols-5 lg:grid-cols-5': customers.length === 5,
        'grid-cols-3 md:grid-cols-3 lg:grid-cols-6': customers.length === 6,
        'grid-cols-3 md:grid-cols-4 lg:grid-cols-7': customers.length === 7,
        'grid-cols-2 md:grid-cols-4 lg:grid-cols-4': customers.length === 8,
        'grid-cols-2 md:grid-cols-5 lg:grid-cols-5': customers.length === 10
      })}
    >
      {customers.map(customer => (
        <Image
          loading="eager"
          priority
          key={customer.alt}
          src={customer.url}
          alt={customer.alt}
          width="100%"
          height={50}
        />
      ))}
    </div>
  </div>
);

LogoGridUI.defaultProps = {
  text: 'Trusted by the world’s most ambitious AI teams.',
  customers: []
};

export default LogoGridUI;
